import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { COMMODITIES } from "Constants/Commodities";
import TextField from "@material-ui/core/TextField";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  ApprovalWorkflow,
  CommonReducerAction,
} from "../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import TabContainer from "../../../../../../Component/Common/TabContainer";
import AttendanceWorkflow from "./AttendanceWorkflow";
import GeneralWorkflow from "./GeneralWorkflow";
import LeaveWorkflow from "./LeaveWorkflow";
import ExitWorkflow from "./ExitWorkflow";
import ExpenseWorkflow from "./ExpenseWorkflow";
import ReviewWorkflow from "./ReviewWorkflow";
import TextArea from "../../../../../../Component/Material-ui/TextArea";
import { isSpaceInString } from "Utils";

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

class ApprovalWorkFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isskippable: false,
      comodities: [],
      approvalworkflowpolicyid: this.props.match.params.workflowid,
      value: "D",
      id: "D",
      nextid: "",
      expanded01: false,
      expanded02: false,
      expanded03: false,
      expanded04: false,
      expanded05: false,
      expanded06: false,
      expanded07: false,
      expanded08: false,
      dropdown: [
        { displayvalue: 1, displayname: "Employee First" },
        { displayvalue: 2, displayname: "Employee Second" },
      ],
      levelEmp: [],
      selectedApproverTypeIds: [],
      approverTypes: [],
      ErName: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("approvalworkflow");
    // this.props.ChangeLanguage("navigation,approvalworkflow");
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getComodities();
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.GetApproverType();
    this.props.CommonReducerAction("CLEARAPPROVALWORKFLOW", {});
    setTimeout(() => {
      this.GetApprovalWorkflowPolicyDetails();
    }, 500);
  }

  getComodities() {
    // const { subscriptionid } = this.props.SubscriptionInfo.SubscriptionData;
    instance
      .get(`superuser/getcommoditybycommoditytypeid/0/1/1`)
      .then((result) => {
        this.setState({
          comodities: result.data.result.filter((data) => data.active == 1),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  componentWillReceiveProps(props) {
    const approvalworkflowdetails = props.approvalWorkflowReducer;
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  OnTabChange = (value, id, nextid) => {
    this.setState({ value, id, nextid });
  };

  setTabValue(value) {
    const getNextTab = (index) => {
      if (this.state.comodities[index]) {
        let x = 0;
        Object.keys(COMMODITIES).forEach((key) => {
          if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "TRACK"
          ) {
            x = "A";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "PAY"
          ) {
            x = "E";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "HRIS"
          ) {
            x = "H";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "PERFORM"
          ) {
            x = "P";
          } else {
          }
        });
        return x;
      }
    };
    if (value == "G") {
      this.setState({ value, id: value, nextid: getNextTab(0) });
    } else if (value == "A") {
      this.setState({ value: COMMODITIES.TRACK, id: value, nextid: "L" });
    } else if (value == "L") {
      const index = this.state.comodities.findIndex(
        (com) => com.commodityid == COMMODITIES.TRACK,
      );
      const ind = this.state.comodities.findIndex(
        (com, i) =>
          i > index &&
          com.commodityid != COMMODITIES.RECRUIT &&
          com.commodityid != COMMODITIES.RESOLVE &&
          com.commodityid != COMMODITIES.STORE,
      );
      this.setState({
        value: COMMODITIES.TRACK,
        id: value,
        nextid: getNextTab(ind),
      });
    } else if (value == "E") {
      const index = this.state.comodities.findIndex(
        (com) => com.commodityid == COMMODITIES.PAY,
      );
      const ind = this.state.comodities.findIndex(
        (com, i) =>
          i > index &&
          com.commodityid != COMMODITIES.RECRUIT &&
          com.commodityid != COMMODITIES.RESOLVE &&
          com.commodityid != COMMODITIES.STORE,
      );
      this.setState({
        value: COMMODITIES.PAY,
        id: value,
        nextid: getNextTab(ind),
      });
    } else if (value == "H") {
      const index = this.state.comodities.findIndex(
        (com) => com.commodityid == COMMODITIES.HRIS,
      );
      const ind = this.state.comodities.findIndex(
        (com, i) =>
          i > index &&
          com.commodityid != COMMODITIES.RECRUIT &&
          com.commodityid != COMMODITIES.RESOLVE &&
          com.commodityid != COMMODITIES.STORE,
      );
      this.setState({
        value: COMMODITIES.HRIS,
        id: value,
        nextid: getNextTab(ind),
      });
    } else if (value == "P") {
      const index = this.state.comodities.findIndex(
        (com) => com.commodityid == COMMODITIES.PERFORM,
      );
      const ind = this.state.comodities.findIndex(
        (com, i) =>
          i > index &&
          com.commodityid != COMMODITIES.RECRUIT &&
          com.commodityid != COMMODITIES.RESOLVE &&
          com.commodityid != COMMODITIES.STORE,
      );
      this.setState({
        value: COMMODITIES.PERFORM,
        id: value,
        nextid: getNextTab(ind),
      });
    }
  }

  OnNameChange(e) {
    this.setState({ name: e.target.value });
  }

  OnDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  Validate() {
    let isValid = true;
    let ErName = false;
    if (this.state.name && !isSpaceInString(this.state.name)) {
      this.state.name = this.state.name.trim();
    }


    if (!this.state.name) {
      ErName = true;
      this.setState({ ErName });
      this.props.enqueueSnackbar("Please Enter Workflow policy Name", {
        variant: "error",
      });
      return (isValid = false);
    }
    if (!/[a-zA-Z]/.test(this.state.name)) {
      ErName = true;
      this.setState({ ErName });
      this.props.enqueueSnackbar("Please Enter Valid Name", {
        variant: "error",
      });
      return (isValid = false);
    }
    this.setState({ ErName });
    return isValid;
  }

  GetApproverType() {
    instance
      .get("superuser/getmastercode/ApproverType")
      .then((result) => {
        let approverTypes = [];
        result.data.result.length > 0
          ? (approverTypes = result.data.result)
          : (approverTypes = []);
        // approverTypes.push({ "displayname": "Select Approver", "displayvalue": "" }, ...result.data.result)
        this.setState({ approverTypes });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetApprovalWorkflowPolicyDetails() {
    if (this.state.approvalworkflowpolicyid) {
      const URL = `/subscription/approvalworkflowpolicydetails/${this.state.approvalworkflowpolicyid}`;
      instance
        .get(URL)
        .then((result) => {
          const Details = result.data.result;
          let data = {};
          result.data.result.approvalWorkFlowPolicy.length > 0
            ? (data = result.data.result.approvalWorkFlowPolicy[0])
            : (data = {});
          const { approvalworkflowpolicyid } = data;
          const name = data.approvalworkflowpolicyname;
          const { description } = data;
          this.setState(
            {
              Details,
              approvalworkflowpolicyid,
              name,
              description,
            },
            () => {
              this.AssignAllDetailsToReducer();
            },
          );
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  AssignAllDetailsToReducer() {
    const { Details } = this.state;

    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalworkflowpolicyname = this.state.name;
    approvalworkflowdetail.description = this.state.description;
    approvalworkflowdetail.isskippable = this.state.isskippable;
    approvalworkflowdetail.approvalworkflowpolicyid = this.state
      .approvalworkflowpolicyid
      ? this.state.approvalworkflowpolicyid
      : null;

    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });

    Details.approvalWorkFlowDetailPolicy.map((data) => {
      const approvalworkflowdetailid = data.approvalworkflowdetailid
        ? data.approvalworkflowdetailid
        : 0;
      const { approvalworkflowpolicyid } = data;
      const { workflowfortypeid } = data;
      const { isselfapproval } = data;
      const { backupemployeeid } = data;
      const { escalationdays } = data;
      const { escalationactiontypeid } = data;
      const { onapproverchange } = data;
      const { approvalworkflowtypeid } = data;
      let expanded01 = false;
      let expanded02 = false;
      let expanded03 = false;
      let expanded04 = false;
      let expanded05 = false;
      let expanded06 = false;
      let expanded10 = false;
      let expanded09 = false;
      let showEmployeeList;
      if (data.approvalworkflowtypeid == 4) {
        expanded01 = true;
      }
      if (data.approvalworkflowtypeid == 1) {
        expanded02 = true;
      }
      if (data.approvalworkflowtypeid == 2) {
        expanded03 = true;
      }
      if (data.approvalworkflowtypeid == 3) {
        expanded04 = true;
      }
      data.escalationdays ? (expanded05 = true) : (expanded06 = true);
      if (data.isselfapproval == true) {
        expanded10 = true;
      }
      if (data.isselfapproval == false) {
        expanded09 = true;
      }

      const approvertypeids = [];
      const selectedApproverTypeIds = [];
      const employeeIds = [];
      const selectedEmployeeIds = [];
      const LevelWiseData = [];

      if (data.approvalworkflowtypeid != 3) {
        console.log("this.state.approverTypes: ", this.state.approverTypes);
        console.log(" Details.approverDetail: ", Details.approverDetail);
        Details.approverDetail.forEach((info) => {
          console.log("info: ", info);
          if (info.approvalworkflowdetailid == approvalworkflowdetailid) {
            const selectedApprover = this.state.approverTypes.find(
              (x) => x.displayvalue == info.approvertypeid,
            );
            const obj = {
              displayname: selectedApprover && selectedApprover.displayname,
              displayvalue: selectedApprover && selectedApprover.displayname,
            };
            if (selectedApprover) {
              obj.approvalworkflowdetailid = approvalworkflowdetailid;
              obj.approverdetailid = info.approverdetailid;
              obj.employeeid = info.employeeid;
            }
            selectedApproverTypeIds.push(obj);
            console.log("approvertypeids: ", approvertypeids);
            if (!approvertypeids.find((x) => x == info.approvertypeid)) {
              approvertypeids.push(info.approvertypeid);
            }
            if (info.approvertypeid == 3) {
              showEmployeeList = true;
              // let selectedEmployee = this.state.employeeList.find(x => x.displayvalue == info.employeeid);
              // selectedEmployeeIds.push(selectedEmployee)
              employeeIds.push(info.employeeid);
            }
          }
        });
      } else {
        const uniqueLevels = [];
        Details.approverDetail.forEach((info) => {
          if (uniqueLevels.indexOf(info.levelid) === -1) {
            uniqueLevels.push(info.levelid);
          }
        });
        uniqueLevels.forEach((level) => {
          const obj = {
            levelName: "",
            levelId: "",
            approverTypeIds: [],
            selectedApproverTypeIds: [],
            selectedEmployee: "",
            employeeId: "",
          };
          Details.approverDetail.map((info) => {
            if (
              info.approvalworkflowdetailid == approvalworkflowdetailid &&
              info.approvertypeid &&
              level == info.levelid
            ) {
              // if(info.approvertypeid && level == info.levelid){
              const selectedApprover = this.state.approverTypes.find(
                (x) => x.displayvalue == info.approvertypeid,
              );
              selectedApprover.approverdetailid = info.approverdetailid;
              obj.selectedApproverTypeIds.push(selectedApprover);
              if (!obj.approverTypeIds.find((x) => x == info.approvertypeid)) {
                obj.approverTypeIds.push(info.approvertypeid);
              }
              obj.approverdetailid = info.approverdetailid;
              obj.approvalworkflowdetailid = approvalworkflowdetailid;
              obj.levelName = `Level-${info.levelid}`;
              obj.levelId = info.levelid;
              if (info.approvertypeid == 3) {
                obj.showEmployeeList = true;
                // obj.selectedEmployee = this.state.employeeList.find(x => x.displayvalue == info.employeeid);
                obj.employeeId = info.employeeid;
              }
            }
          });
          LevelWiseData.push(obj);
        });
      }

      let policyObj;
      policyObj = {
        approvalworkflowdetailid: approvalworkflowdetailid || 0,
        workflowfortypeid,
        isselfapproval,
        backupemployeeid: backupemployeeid || null,
        escalationdays: escalationdays || null,
        escalationactiontypeid: escalationactiontypeid || null,
        onapproverchange,
        approvalworkflowtypeid,
        approverdetail: [],
        approvalpermission: data.approvalpermission || null,
      };

      console.log("selectedApproverTypeIds: ", selectedApproverTypeIds);
      selectedApproverTypeIds.forEach((approvertype) => {
        const approverTypeItem = {
          approvalworkflowdetailid: approvalworkflowdetailid || 0,
          approverdetailid: approvertype.approverdetailid
            ? approvertype.approverdetailid
            : 0,
          approvertypeid: approvertype.displayvalue,
          employeeid: approvertype.employeeid,
          levelid: 1,
        };
        // if (approvertype.displayvalue == 3) {
        //     employeeIds.forEach((employeeId) => {
        //         const employeeItem = {
        //             approvalworkflowdetailid: approvalworkflowdetailid || 0,
        //             approverdetailid: approvertype.approverdetailid ? approvertype.approverdetailid : 0,
        //             approvertypeid: approvertype.displayvalue,
        //             employeeid: employeeId,
        //             levelid: 1,
        //         };
        //         if (!policyObj.approverdetail.find((apr) => apr.employeeid == employeeId)) {
        policyObj.approverdetail.push(approverTypeItem);
        //     }
        // });
        // }
        if (approvertype.displayvalue != 3) {
          policyObj.approverdetail.push(approverTypeItem);
        }
      });

      LevelWiseData.map((levelData) => {
        levelData.selectedApproverTypeIds.map((approvertype) => {
          const approverTypeItem = {
            approvalworkflowdetailid: approvalworkflowdetailid || 0,
            approverdetailid: approvertype.approverdetailid
              ? approvertype.approverdetailid
              : 0,
            approvertypeid: approvertype.displayvalue,
            employeeid: null,
            levelid: levelData.levelId,
          };
          if (approvertype.displayvalue == 3) {
            const employeeItem = {
              approvalworkflowdetailid: approvalworkflowdetailid || 0,
              approverdetailid: approvertype.approverdetailid
                ? approvertype.approverdetailid
                : 0,
              approvertypeid: approvertype.displayvalue,
              employeeid: levelData.employeeId,
              levelid: levelData.levelId,
            };

            policyObj.approverdetail.push(employeeItem);
          }
          if (approvertype.displayvalue != 3) {
            policyObj.approverdetail.push(approverTypeItem);
          }
        });
      });

      const approvalworkflowInfo = this.props.approvalWorkflowReducer;
      if (approvalworkflowInfo.approvalworkflowdetail) {
        const index = approvalworkflowInfo.approvalworkflowdetail.findIndex(
          (x) => x.workflowfortypeid == data.workflowfortypeid,
        );
        index > -1
          ? (approvalworkflowInfo.approvalworkflowdetail[index] = policyObj)
          : approvalworkflowInfo.approvalworkflowdetail.push(policyObj);
      } else {
        approvalworkflowInfo.approvalworkflowdetail = [];
        approvalworkflowInfo.approvalworkflowdetail.push(policyObj);
      }

      this.props.ApprovalWorkflow({ ...approvalworkflowInfo });
      // this.setState({ approvalworkflowdetailid,approvalworkflowpolicyid,workflowfortypeid,approvalworkflowtypeid,
      //     isselfapproval,backupemployeeid,escalationdays,escalationactiontypeid,onapproverchange,
      //     expanded01,expanded02,expanded03,expanded04,expanded05,expanded06,expanded10,expanded09,showEmployeeList,
      //     approvertypeids,selectedApproverTypeIds,selectedEmployeeIds,employeeIds,LevelWiseData },()=>{
      //         this.UpdateReducer()
      //     })
    });
  }

  UpdateApprovalWorkFlowReducer() {
    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalworkflowpolicyname = this.state.name;
    approvalworkflowdetail.description = this.state.description;
    approvalworkflowdetail.approvalworkflowpolicyid = this.state
      .approvalworkflowpolicyid
      ? this.state.approvalworkflowpolicyid
      : null;

    // this.props.ApprovalWorkflow({ ...approvalworkflowdetail, approvalworkflowpolicyname, description, approvalworkflowpolicyid })
    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });
  }

  OnSave() {
    if (!this.Validate()) {
      // this.props.enqueueSnackbar('Please select all required fields', { variant: 'error' })
    } else {
      this.UpdateApprovalWorkFlowReducer();
      this.setTabValue("G");
    }
  }

  render() {
    const { classes } = this.props;
    const { value, id } = this.state;
    const language = this.props.Language.approvalworkflow;
    const getNextTab = (index) => {
      if (this.state.comodities[index]) {
        let x = 0;
        Object.keys(COMMODITIES).forEach((key) => {
          if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "TRACK"
          ) {
            x = "A";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "PAY"
          ) {
            x = "E";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "HRIS"
          ) {
            x = "H";
          } else if (
            this.state.comodities[index].commodityid == COMMODITIES[key] &&
            key == "PERFORM"
          ) {
            x = "P";
          } else {
          }
        });
        return x;
      }
    };
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <div className="common-menubar-header-scrollable">
            <Tabs value={value} indicatorColor="#fff" textColor="primary">
              <Tab
                onClick={() => this.OnTabChange("D", "D", "G")}
                label={
                  <FormattedMessage
                    id="LbDefineWorkflow"
                    defaultMessage="Define Workflow"
                  />
                }
                className={`tabheading ${
                  this.state.id == "D" ? "active-tab1" : "inactive-tab1"
                } `}
              />
              <Tab
                onClick={() => this.OnTabChange("G", "G", getNextTab(0))}
                label={
                  <FormattedMessage
                    id="__LbHrisWorkflow"
                    defaultMessage="HRIS Workflow"
                  />
                }
                className={`tabheading ${
                  this.state.id == "G" ? "active-tab1" : "inactive-tab1"
                } `}
              />
              {this.state.comodities.map((x, index) => {
                if (x.commodityid == COMMODITIES.TRACK) {
                  return (
                    <div
                      className="MuiButtonBase-root MuiTab-root"
                      style={{ maxWidth: 374 }}
                    >
                      <Tab
                        textColor="primary"
                        onClick={() =>
                          this.OnTabChange(x.commodityid, "A", "L")
                        }
                        label={
                          <FormattedMessage
                            id="LbAttendanceWorkflow"
                            defaultMessage="Attendance Workflow"
                          />
                        }
                        className={`tabheading ${
                          this.state.id == "A" ? "active-tab1" : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        textColor="primary"
                        onClick={() =>
                          this.OnTabChange(
                            x.commodityid,
                            "L",
                            getNextTab(
                              this.state.comodities.findIndex(
                                (com, i) =>
                                  i > index &&
                                  com.commodityid != COMMODITIES.RECRUIT &&
                                  com.commodityid != COMMODITIES.RESOLVE &&
                                  com.commodityid != COMMODITIES.STORE,
                              ),
                            ),
                          )
                        }
                        label={
                          <FormattedMessage
                            id="LbLeaveWorkflow"
                            defaultMessage="Leave Workflow"
                          />
                        }
                        className={`tabheading ${
                          this.state.id == "L" ? "active-tab1" : "inactive-tab1"
                        } `}
                      />
                    </div>
                  );
                } else if (x.commodityid == COMMODITIES.HRIS) {
                  return (
                    <Tab
                      onClick={() =>
                        this.OnTabChange(
                          x.commodityid,
                          "H",
                          getNextTab(
                            this.state.comodities.findIndex(
                              (com, i) =>
                                i > index &&
                                com.commodityid != COMMODITIES.RECRUIT &&
                                com.commodityid != COMMODITIES.RESOLVE &&
                                com.commodityid != COMMODITIES.STORE,
                            ),
                          ),
                        )
                      }
                      label={
                        <FormattedMessage
                          id="LbExitWorkflow"
                          defaultMessage="Exit Workflow"
                        />
                      }
                      className={`tabheading ${
                        this.state.id == "H" ? "active-tab1" : "inactive-tab1"
                      } `}
                    />
                  );
                } else if (x.commodityid == COMMODITIES.PAY) {
                  return (
                    <Tab
                      onClick={() =>
                        this.OnTabChange(
                          x.commodityid,
                          "E",
                          getNextTab(
                            this.state.comodities.findIndex(
                              (com, i) =>
                                i > index &&
                                com.commodityid != COMMODITIES.RECRUIT &&
                                com.commodityid != COMMODITIES.RESOLVE &&
                                com.commodityid != COMMODITIES.STORE,
                            ),
                          ),
                        )
                      }
                      label={
                        <FormattedMessage
                          id="LbExpenseWorkflow"
                          defaultMessage="Expense Workflow"
                        />
                      }
                      className={`tabheading ${
                        this.state.id == "E" ? "active-tab1" : "inactive-tab1"
                      } `}
                    />
                  );
                } else if (x.commodityid == COMMODITIES.PERFORM) {
                  return (
                    <Tab
                      onClick={() =>
                        this.OnTabChange(
                          x.commodityid,
                          "P",
                          getNextTab(
                            this.state.comodities.findIndex(
                              (com, i) =>
                                i > index &&
                                com.commodityid != COMMODITIES.RECRUIT &&
                                com.commodityid != COMMODITIES.RESOLVE &&
                                com.commodityid != COMMODITIES.STORE,
                            ),
                          ),
                        )
                      }
                      label={
                        <FormattedMessage
                          id="LbExpenseWorkflow"
                          defaultMessage="360 Degree Review Workflow"
                        />
                      }
                      className={`tabheading ${
                        this.state.id == "P" ? "active-tab1" : "inactive-tab1"
                      } `}
                    />
                  );
                }
                return "";
              })}
              {/* <Tab label={<FormattedMessage id="LbAttendanceWorkflow" defaultMessage="Attendance Workflow" />} className={`tabheading ${this.state.value == 2 ? "active-tab1" : "inactive-tab1"} `} />
                                <Tab label={<FormattedMessage id="LbLeaveWorkflow" defaultMessage="Leave Workflow" />} className={`tabheading ${this.state.value == 3 ? "active-tab1" : "inactive-tab1"} `} />
                                <Tab label={<FormattedMessage id="LbExitWorkflow" defaultMessage="Exit Workflow" />} className={`tabheading ${this.state.value == 4 ? "active-tab1" : "inactive-tab1"} `} />
                                <Tab label={<FormattedMessage id="LbExpenseWorkflow" defaultMessage="Expense Workflow" />} className={`tabheading ${this.state.value == 5 ? "active-tab1" : "inactive-tab1"} `} />
                                <Tab label={<FormattedMessage id="LbExpenseWorkflow" defaultMessage="360 Degree Review Workflow" />} className={`tabheading ${this.state.value == 6 ? "active-tab1" : "inactive-tab1"} `} /> */}
            </Tabs>
            <div className="tab-border"></div>
          </div>
          <main className="content-outer-wrapper">
            <div className={classes.root}>
              {id === "D" && (
                <TabContainer>
                  <div style={{ width: "60%" }}>
                    <p className="form-sub-header">
                      <FormattedMessage
                        id="LbApprovalWorkflow"
                        defaultMessage="Kindly Define your approval workflow details"
                      />
                    </p>
                    <div className="device-wrapper">
                      <p className="form-input-label">
                        <FormattedMessage
                          id="LbWorkflowName"
                          defaultMessage="Workflow Name"
                        />
                      </p>
                      {/* <input type="text" className="form-control width-imp "
                                                autoComplete="off"
                                                autoFocus placeholder="Workflow Name"
                                                onChange={this.OnNameChange.bind(this)}
                                                value={this.state.name}
                                                maxLength="40"
                                            /> */}
                      <TextField
                        id="outlined-dense"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        style={{ width: "100%" }}
                        placeholder="Enter Workflow Name"
                        onChange={this.OnNameChange.bind(this)}
                        value={this.state.name}
                        maxLength="100"
                        className="form-text-input"
                        autoFocus
                      />
                      <div>
                        {this.state.ErName == true ? (
                          <span className="caption-error">
                            <FormattedMessage
                              id="ErName"
                              defaultMessage="name can not be empty"
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="device-wrapper">
                      <p className="form-input-label">
                        <FormattedMessage
                          id="LbInternalDescription"
                          defaultMessage="Internal description for other admins who would view this setting"
                        />
                      </p>
                      {/* <textarea className="width50 input-area-section " placeholder="Description "
                                                onChange={this.OnDescriptionChange.bind(this)}
                                                value={this.state.description}
                                                maxLength="200" /> */}
                      <TextArea
                        className="width100"
                        maxLength="200"
                        variant="outlined"
                        placeholder="Description "
                        multiline
                        onChange={this.OnDescriptionChange.bind(this)}
                        value={this.state.description}
                      />
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        size="large"
                        onClick={this.OnSave.bind(this)}
                      >
                        Save & next
                      </Button>
                    </div>
                  </div>
                </TabContainer>
              )}
              {id === "G" && (
                <TabContainer>
                  <GeneralWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
              {id === "A" && value == COMMODITIES.TRACK && (
                <TabContainer>
                  <AttendanceWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
              {id === "L" && value == COMMODITIES.TRACK && (
                <TabContainer>
                  <LeaveWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    {...this.props}
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
              {id === "H" && value == COMMODITIES.HRIS && (
                <TabContainer>
                  <ExitWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    {...this.props}
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
              {id === "E" && value == COMMODITIES.PAY && (
                <TabContainer>
                  <ExpenseWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    {...this.props}
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
              {id === "P" && value == COMMODITIES.PERFORM && (
                <TabContainer>
                  <ReviewWorkflow
                    setTabValue={this.setTabValue.bind(this)}
                    approvalworkflowpolicyid={
                      this.state.approvalworkflowpolicyid
                    }
                    {...this.props}
                    nextid={this.state.nextid}
                  />
                </TabContainer>
              )}
            </div>
          </main>
        </div>
      </IntlProvider>
    );
  }
}

ApprovalWorkFlow.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  approvalWorkflowReducer: state.approvalWorkflowReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ApprovalWorkflow: (data) => ApprovalWorkflow(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ApprovalWorkFlow)));
